<template>
    <div class="welcome">
        <div class="hello">
            <img src="../assets/abi.png" alt="" class="logo-abi" />
            <div class="wrap-title">
                <h3 class="title">Selamat Akun Anda Telah Terverifikasi!</h3>
                <h5>Silahkan Melakukan Demo Terlebih Dahulu. Akun demo akan dikirim ke email anda oleh admin kami</h5>
            </div>

            <router-link to="/login">
                <button class="btn-new">Masuk</button>
            </router-link>

            <!-- <a
        :href="'https://trade.mql5.com/trade?version=5&referrer=www.google.com&ref=b839c1854705ace2c6a5b6274be1d99f66bdfdd8b3301097afa85e5cb561c316'"
        target="_blank"
      >
        <button class="btn-new">Buka Demo</button>
      </a> -->
            <!-- <div class="demo">
        <div>Buka Demo untuk Mencoba Trading Platform Metal X</div>
        
      </div> -->
        </div>
    </div>
</template>

<script>
export default {
    name: "HelloWorld",
    props: {
        msg: String,
    },
    data() {
        return {
            urlDemo: "",
        };
    },
    mounted() {
        this.urlDemo = localStorage.getItem("url_demo");
        // console.log(this.urlDemo);
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.welcome {
    height: 100vh;
    position: relative;
}

.hello {
    background-image: url("../assets/bg.png");
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    color: #1e354a;
}

.wrap-title {
    text-align: center;
    margin-bottom: 50px;
}

.btn-new {
    width: 190px;
    height: 54px;
    padding: 10px 23px;
    background-color: #c59733;
    border-radius: 43px;
    border: none;
    color: white;
    font-size: 22px;
    font-weight: bold;
    margin-bottom: 49px;
}

.btn-scondary-new {
    width: 124px;
    height: 36px;
    padding: 10px 25px;
    border: none;
    border-radius: 17.5px;
    background-color: #c59733;
    color: white;
    font-size: 13px;
}

.btn-scondary-new:hover,
.btn-new:hover {
    background-color: #997528;
}

.hello {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 7rem;
}

.logo {
    background-color: #c59733;
}

.logo-abi {
    width: 110px;
    margin: 45px 0 40px 0;
}

.title {
    font-size: 42px;
    font-weight: bold;
    color: #1e354a;
}

.demo {
    border-top: solid 1px #1e354a;
    width: 371px;
    padding: 23px 15px;
    display: flex;
    justify-content: space-between;
}
.demo div {
    width: 177px;
    height: 35px;
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    color: #1e354a;
}

@media (max-width: 720px) {
    .hello {
        padding: 1rem;
    }

    .logo-abi {
        margin: 1rem 0;
    }
}
</style>
